import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";
import { COMMON_ENTITIES, type IODataMetadataCatalog } from "../declarations/ODataExplorer";

interface IEntityOption {
    group: "Common" | "All";
    name: string;
}

interface IEntityPickerProps {
    catalog: IODataMetadataCatalog;
    onChange: (entity: string) => void;
    value: string;
}

export default function EntityPicker({ catalog, onChange, value }: IEntityPickerProps) {
    const options: IEntityOption[] = React.useMemo(() => {
        const allNames = Object.keys(catalog.entities).sort((a, b) => a.localeCompare(b));
        const commonSet = new Set(COMMON_ENTITIES.filter((c) => allNames.includes(c)));
        const common: IEntityOption[] = [...commonSet].map((name) => ({ group: "Common", name }));
        const all: IEntityOption[] = allNames.map((name) => ({ group: "All", name }));
        return [...common, ...all];
    }, [catalog]);

    const selected = options.find((o) => o.group === "All" && o.name === value) ?? null;

    return (
        <Autocomplete
            getOptionLabel={(o) => o.name}
            groupBy={(o) => o.group}
            isOptionEqualToValue={(a, b) => a.name === b.name && a.group === b.group}
            onChange={(_, option) => onChange(option?.name ?? "")}
            options={options}
            renderInput={(params) => <TextField {...params} label="Entity" />}
            sx={{ minWidth: 320 }}
            value={selected}
            size="small"
        />
    );
}
